module.exports = __webpack_public_path__ + "img/reference08.df88bd4e.jpg";